import React, { useState, useEffect, useCallback, useContext } from 'react';
import SharePublicProfilePopUp from './SharePublicProfilePopUp';
import AlertContext from '../../context/AlertContext';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import Loading from '../Notification-Loading/Loading/Loading';
import constants from "../../constants";
/**
 * SharePublicProfileButton Component
 * Allows authenticated users to share their profile publicly
 * Shows Gradious URL and copy button
 */

const svgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 20 22" fill="none">
<path d="M6.59 12.51L13.42 16.49M13.41 5.51L6.59 9.49M19 4C19 5.65685 17.6569 7 16 7C14.3431 7 13 5.65685 
13 4C13 2.34315 14.3431 1 16 1C17.6569 1 19 2.34315 19 4ZM7 11C7 12.6569 5.65685 14 4 14C2.34315 14 1 12.6569 
1 11C1 9.34315 2.34315 8 4 8C5.65685 8 7 9.34315 7 11ZM19 18C19 19.6569 17.6569 21 16 21C14.3431 21 13 19.6569 
13 18C13 16.3431 14.3431 15 16 15C17.6569 15 19 16.3431 19 18Z" stroke="#667085" stroke-width="2" stroke-linecap="round" 
stroke-linejoin="round"/>
</svg> );

const SharePublicProfileButton = ({ containerClassName = "" }) => {
  const { setIsLoaded, setShowNotify, isLoaded } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const [isShared, setIsShared] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [publicUrl, setPublicUrl] = useState(null);
  const [openModal, setOpenModal] = useState(false);

   const sharePublicUrl = useCallback(async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `/node/learner/gradious/public-url`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          } 
        );

        console.log("response in SharePublicProfileButton", response, process.env.REACT_APP_PUBLIC_PROFILE_BASE_URL);
  
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const url = `${process.env.REACT_APP_URL}${response.data.publicUrl}`;
          setPublicUrl(url);
          setOpenModal(true);
        } else {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg:
              response.data.msg ||
              "Something went wrong. Please try again later.",
          });
        }
      } catch (error) {
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
        } else
          setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later or contact gradious team.",
          });
      } finally {
        setIsLoading(false);
      }
    }, []);


    const handleProfile = async() => {
      await sharePublicUrl();
    }



  return (
    <>
      <div className={`share-public-profile-container ${containerClassName}`.trim()}>
        <div className="share-public-profile-content" onClick={handleProfile}>
          <span className='share-public-profile-icon' >{svgIcon}</span>
          <span className='share-public-profile-text'>Share Profile</span>
        </div>
      </div>

      <SharePublicProfilePopUp 
        openModal={openModal} 
        setOpenModal={setOpenModal} 
        publicUrl={publicUrl}
      />
    </>
  );
};

export default SharePublicProfileButton;
